const goalData = [
  {
    name: '体重',
    text: '体重下降',
    icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/2ac1f9fc6a1f1d7245a2d975702c9611_wh=192_192.webp',
    id: 1,
    btn: '挑战A',
    unit: 'kg'
  },
  {
    name: '腰围',
    text: '腰围减少',
    icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/23f51a1a94a6207666da8e6cabd6a842_wh=192_192.webp',
    id: 2,
    btn: '挑战B',
    unit: 'cm'
  },
  {
    name: '体脂率',
    text: '体脂率下降',
    icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/38f4bba04c83acce5b4ea8ad6522bfe4_wh=192_192.webp',
    id: 3,
    btn: '挑战C',
    unit: '%'
  }
]
export { goalData }
